









































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import SecondHand from "../../store/entities/booking/secondHand";
import Editor from "@tinymce/tinymce-vue";
import TinymceInit from "../../lib/TinymceInit";
import MultiPicture from "../../components/multi-picture.vue";
import Ajax from "../../lib/ajax";
import appconst from "../../lib/appconst";

TinymceInit.height = 300;

@Component({
    components: { Editor, MultiPicture }
})
export default class EditSecondHand extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;

    secondHand: SecondHand = new SecondHand();

    tinymceInit = TinymceInit;

    get extData() {
        return {
            secondHandId: this.secondHand.id
        };
    }

    onSecondHandImageDeleted(id) {
        console.log("DeleteSecondHandImageId:" + id);
        Ajax.delete("/api/services/app/SecondHandImage/Delete?id=" + id)
            .then(() => {})
            .catch(() => {
                this.$Message.error("图片删除失败");
            });
    }

    created() {}

    save() {
        (this.$refs.secondHandForm as any).validate(async (valid: boolean) => {
            if (valid) {
                await this.$store.dispatch({
                    type: "secondHand/updateWithImages",
                    data: {
                        secondHand: this.secondHand,
                        secondHandImages: this.secondHand.secondHandImages
                    }
                });
                (this.$refs.secondHandForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.secondHandForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.secondHand = Util.extend(
                true,
                {},
                this.$store.state.secondHand.editSecondHand
            );
        }
    }

    secondHandRule = {
        title: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("Title")),
                trigger: "blur"
            },
            {
                type: 'string',
                max: 512,
                message: this.L("NoMoreThenLength",undefined,this.L("Title"),"512"),
                trigger: "blur"
            }
        ],
        publishName: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("LinkMan")),
                trigger: "blur"
            },
            {
                type: 'string',
                max: 512,
                message: this.L("NoMoreThenLength",undefined,this.L("LinkMan"),"16"),
                trigger: "blur"
            }
        ],
        address: [
            {
                type: 'string',
                max: 512,
                message: this.L("NoMoreThenLength",undefined,this.L("Address"),"512"),
                trigger: "blur"
            }
        ],
        phoneNumber: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("PhoneNumber")),
                trigger: "blur"
            },
            {
                type: 'string',
                max: 32,
                message: this.L("NoMoreThenLength", undefined , this.L("PhoneNumber"), "32"),
                trigger: "blur"
            },
            {
                pattern: /(^1[3456789]\d{9}$)|(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,6})?$)/,
                message: this.L("IncorrectFormat",undefined,this.L("PhoneNumber")),
                trigger: "blur"
            }
        ],
        description: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("Description")),
                trigger: "blur"
            }
        ]
    };
}
